import { analytics } from "@/lib/analytics/metrics"

export const useAnalytics = () => {
  return {
    track: analytics.trackEvent
  }
}